<script lang="ts">
  import FicheEtablissement from '@/generated/fiches/FicheEtablissement.vue';
  import { storeAdresse, storePaymentMeans, storeSession } from '@/generated/stores';
  import { Extended } from '@/framework/base/classes/Schema';
  import { FractionDsnTypes } from '@/generated/classes/FractionDsn';
  import UserProfile, { EnumProfile } from "@/framework/base/classes/UserProfile";
  import PaymentMeans from '@/generated/classes/PaymentMeans';
  import Adresse from '@/extend/classes/Adresse';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import Owner from '../classes/Owner';
  import { defineComponent } from "vue";
  import { ListFilter } from '@/generated/classes/ListData';

  export default defineComponent({
    components: {},
    extends: FicheEtablissement,
    data () {
      return {
        paymentMeans: new PaymentMeans()
      };
    },
    computed: {
      selectedAdresse (): Adresse {
        if (this.adresse.id < 0) {
          storeAdresse.mAdresseDeleted(this.adresse.id);
        }
        this.updateAdresseOwner();
        return this.adresse;
      },
      isSalarie (): boolean {
        let res = false;
        const user = storeSession.connectedUser;
        if (user) {
          res = UserProfile.hasProfile(user, EnumProfile.salarie);
        }
        return res;
      }
    },
    methods: {
      updateAdresseOwner () {
        if (this.etablissement.adresseId == 0) {
          this.adresse = storeAdresse.createNewAdresse();
        } else {
          this.adresse = storeAdresse.getAdresse(this.etablissement.adresseId);
        }
        this.adresse.owner = new Owner()
        this.adresse.owner.objType = ObjTypes.CONTACT;
        this.adresse.owner.objId = this.etablissement.id;
      },
      isDisplayed (value: string): boolean {
        if (this.etablissement.id < 0 && value == 'ETABLISSEMENT_IDENTITE') {
          this.setExtended(new Extended('ETABLISSEMENT_IDENTITE', this.fiche, true));
        }
        if (value == 'ETABLISSEMENT_AFFILIATIONS') {
          return !this.isSalarie && this.etablissement.id > 0;
        }
        if (value == 'ETABLISSEMENT_CAISSES') {
          return !this.isSalarie && this.etablissement.id > 0;
        }
        if (value == 'ACCIDENT_TRAVAIL_LIST') {
          return !this.isSalarie && this.etablissement.id > 0;
        }
        if (value == 'GESTIONNAIRES_PAIE') {
          return !this.isSalarie && this.etablissement.id > 0;
        }
        if (value == 'ETABLISSEMENT_LOGO') {
          return !this.isSalarie && this.etablissement.id > 0;
        }
        if (value == 'ETABLISSEMENT_DOCUMENT_LIST') {
          return !this.isSalarie && this.etablissement.id > 0;
        }
        if (value == 'PAYMENT_MEANS_LIST') {
          return false;
        }
        if (value == 'ABONNEMENT') {
          return !this.isSalarie && this.etablissement.id > 0;
        }
        if (value == 'REGLEMENT_LIST') {
          return !this.isSalarie && this.etablissement.id > 0 && this.etablissement.hasBillItems;
        }
if (value == 'SALAIRE_MEANS') {
          return !this.isSalarie && this.etablissement.id > 0;
        }
        if (value == 'PRELEV_MEANS') {
          return !this.isSalarie && this.etablissement.id > 0;
        }
        if (value == 'APPRENTI_LIST') {
          let res = false;
          if (!this.isSalarie) {
            this.etablissement.fractionDsn.forEach((fraction) => {
              if (fraction.type == FractionDsnTypes.PERMANENT || fraction.type == FractionDsnTypes.MIXTE) {
                res = true;
              }
            });
          }
          return res;
        }
        if (value == "ABONNEMENT") {
          return false;
        }
        return this.etablissement.id > 0 || value == 'ETABLISSEMENT_IDENTITE';
      }
    }
  })

</script>
